import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CustomersTable from "src/pages/components/customers/customers-table";
import CreateCustomerModal from "src/pages/components/customers/create-customer-modal";
import { Customer } from "src/api/types/customer.types";
import { Seo } from "src/components/seo";
import { customersApi } from "src/api/endpoints/customers";
import toast from "react-hot-toast";

import BackButton from 'src/components/back-button';

const CustomersPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [error, setError] = useState<string | null>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const limit = 5;

  const fetchCustomers = async (currentPage: number) => {
    try {
      setLoading(true);
      const response = await customersApi.getAllUsers(currentPage, limit);
      if (response.status) {
        const apiUsers = Array.isArray(response?.data?.users) ? response.data.users : [];
        setCustomers(apiUsers);
        const apiTotal = response?.data?.total_users;
        setTotalCount(typeof apiTotal === 'number' ? apiTotal : apiUsers.length);
      } else {
        console.error("Failed to fetch customers data");
      }
    } catch (error) {
      if (error?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("current_user");

        toast.error("Session expired. Please login again.");
        window.location.href = "/";
      } else if (error?.response?.status === 403) {
        toast.error(error.response.data.message || "Operation not permitted");
        setError(error.response.data.message || "Operation not permitted");
      } else {
        setError("Failed to fetch customers data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers(page);
  }, [page]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleCreateSuccess = () => {
    fetchCustomers(page);
  };

  return (
    <>
      <Seo title="Dashboard: Customer Edit" />
            <Box
              component="main"
              sx={{
          
                py: 2,
                minHeight: '100%',
                width: '100%',
              }}
            >   
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={4}
              sx={{
                mb: "10px",
                px:2
              }}
            >
                 <BackButton/>
              
                <Typography variant="h5">Users</Typography>
             
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                onClick={() => setIsCreateModalOpen(true)}
                sx={{
                  width: "fit-content",
                  p: "8px 15px",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Add User
              </Button>
            </Stack>

            <Box sx={{ width: "100%" , backGroundColor: "green",}}>
              {loading ? (
                <Typography variant="body1">Loading...</Typography>
              ) : (
                <CustomersTable
                  data={Array.isArray(customers) ? [...customers].reverse() : []}
                  totalCount={totalCount}
                  page={page}
                  limit={limit}
                  onPageChange={handlePageChange}
                  onLimitChange={() => {}} // Dummy function as the interface still requires it
                />
              )}
            </Box>
      
   
           </Box>

      <CreateCustomerModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />
    </>
  );
};

export default CustomersPage;
